import { cn } from '@/utils/tailwind';
import React, { forwardRef } from 'react';

interface LayoutOrderContainerProps {
  children: React.ReactNode;
  className?: string;
}

// ref는 forwardRef의 두 번째 인자로만 받으면 됩니다.
export const LayoutOrderContainer = forwardRef<HTMLDivElement, LayoutOrderContainerProps>(
  ({ children, className = '' }, ref) => {
    return (
      <div
        ref={ref ? ref : undefined}
        className={cn('scrollbar relative flex min-h-full w-full flex-col overflow-y-auto', className)}
      >
        {children}
      </div>
    );
  },
);

LayoutOrderContainer.displayName = 'LayoutOrderContainer';

export const LayoutTabSection = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex flex-col    bg-gr-50 pt-[40px] ">
      <div className="flex w-full max-w-full flex-col px-[60px]">{children}</div>
    </div>
  );
};

export const LayoutTables = ({
  children,
  isTableBorder = false,
}: {
  children: React.ReactNode;
  isTableBorder?: boolean;
}) => {
  return (
    <div className="flex w-full flex-1 flex-col  bg-white px-[60px] pb-[36px]">
      <div
        className={`flex  w-full max-w-full flex-1 flex-col rounded-[20px] 
        ${isTableBorder ? 'border border-gr-200' : ''} 
        `}
      >
        {children}
      </div>
    </div>
  );
};

export const LayoutStickySection = ({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'sticky top-0 z-[30] flex w-full max-w-full flex-col  gap-[16px]  bg-white px-[60px] pb-[16px] pt-[20px] backdrop-blur-sm',
        className,
      )}
    >
      {children}
    </div>
  );
};

export const LayoutReviewBodyContent = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex w-full flex-1 flex-col  bg-white  pb-[36px]">
      <div
        className={`flex  w-full max-w-full  flex-1 flex-col rounded-[20px] 
        `}
      >
        {children}
      </div>
    </div>
  );
};
